import { createErrorLogMessage } from '@lmn/nextjs-appfw/dist/logging/utils';
import type { ClientAppLogErrorParams, ClientAppLogPayload } from './types';

const APP_LOGGER_API = '/api/appLogger';

export const createCodeSourceName = (codeSourceName: string): string =>
  `ClientSide:[${codeSourceName}]`;

export const createErrorPayload = ({
  level,
  codeSourceName,
  error,
}: ClientAppLogErrorParams): ClientAppLogPayload => ({
  level,
  codeSourceName: createCodeSourceName(codeSourceName),
  logMessage: createErrorLogMessage(error),
  url: window.location.href,
});

export const sendAppLog = (payload: ClientAppLogPayload) => {
  if (navigator && navigator.sendBeacon) {
    const body = JSON.stringify(payload);
    navigator.sendBeacon(APP_LOGGER_API, body);
  }
};

export const clientAppLog = (params: ClientAppLogPayload) => {
  sendAppLog(params);
};

export const clientAppLogError = (params: ClientAppLogErrorParams) => {
  const payload = createErrorPayload(params);
  sendAppLog(payload);
};
